import {useDebugValue} from 'react';

import {useOptions} from './';

const defaultOptions = {
    autoSubmit: true,
    autoProgress: true,
    layout: 'standard',
    align: 'center',
    showIcons: true,
    showDestinationInput: true,
    showDatesInput: true,
    showGuestsInput: true,
    showSubmitButton: true
};

function useFormOptions(props) {
    const {
        formOptions: propsOptions
    } = props;

    const {
        options
    } = useOptions(defaultOptions, propsOptions);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useFormOptions};
